import axios from 'axios'
import { navigate } from 'gatsby'
import jwtDecode from 'jwt-decode'
import {
  failedSubmissionEvent,
  loginEvent,
  logoutEvent,
  successfullSubmissionEvent,
} from '../components/google-tag-manager/events'
import { loginSuccessToast } from '../components/toasts/login'
import { logoutToast } from '../components/toasts/logout'

const jwt = async () => {
  return typeof window !== 'undefined' && (await getToken('jwt'))
}

const headers = (jwt) => {
  return { headers: { Authorization: `Bearer ${jwt}` }, withCredentials: true }
}

const preflight = (config) => {
  return axios.get(
    `${process.env.GATSBY_PO_BASE_URL}/mvc/api/preflight`,
    config
  )
}

const authUrl = (referrer, otp) => {
  return `${process.env.GATSBY_PO_BASE_URL}/mvc/loggedin?lending=${referrer}&userOtp=${otp}`
}

export const authorize = async (referrer, token) => {
  const fallbackReferrer = referrer || process.env.GATSBY_REFERRER_URL
  const fallbackJwt = token ? token : await jwt()

  try {
    const preflight_response = await preflight(headers(fallbackJwt))
    const otp = preflight_response.data.userOTP

    if (otp && preflight_response.status === 200) {
      window.location.assign(
        authUrl(fallbackReferrer, preflight_response.data.userOTP)
      )
    } else {
      console.log('Invalid jwt: ' + preflight_response)
      throw new Error('Invalid JWT')
    }
  } catch (e) {
    console.log(e)
    localStorage.clear()
    navigate('/logg-inn')
  }
}

export const login = async (data, referrer) => {
  const response = await axios.post(
    `${process.env.GATSBY_PO_BASE_URL}/mvc/api/authenticate`,
    data,
    {
      withCredentials: true,
    }
  )

  if (response && response.status === 200) {
    const decodedToken = jwtDecode(response.data.jwttoken)
    setToken('jwt', response.data.jwttoken, decodedToken.exp)
    authorize(referrer, response.data.jwttoken)
  }

  response.status === 200
    ? successfullSubmissionEvent()
    : failedSubmissionEvent()
  response.status === 200 && loginEvent()
  response.status === 200 && loginSuccessToast()
}

export const resetPassword = async (params) => {
  const formData = new FormData()
  formData.append('username', params)
  const response = await axios.post(
    `${process.env.GATSBY_PO_BASE_URL}/mvc/resetpasswordtoken`,
    formData
  )
  response.status === 200
    ? successfullSubmissionEvent()
    : failedSubmissionEvent()
}

export const getInitials = () => {
  const token = typeof window !== 'undefined' && getToken('jwt')
  if (token) {
    const decodedToken = jwtDecode(token)
    const firstLetter = decodedToken.firstName.charAt(0)
    const lastLetter = decodedToken.lastName.charAt(0)
    return firstLetter + lastLetter
  }
}

export const logout = async () => {
  localStorage.clear()
  logoutToast()
  logoutEvent()
  window.open(`${process.env.GATSBY_PO_BASE_URL}/logout`, '_self').focus()
}

export const register = async (params) => {
  const response = await axios.post(
    `${process.env.GATSBY_PO_BASE_URL}/mvc/apply`,
    params
  )
  response.status === 200
    ? successfullSubmissionEvent()
    : failedSubmissionEvent()
}

const doesTokenExist = () => {
  if (typeof window !== 'undefined') {
    const tokenString = localStorage.getItem('jwt')
    if (!tokenString) {
      return false
    }
    return JSON.parse(tokenString)
  }
}

const isTokenExpired = () => {
  const token = doesTokenExist()
  return new Date().getTime() / 1000 < token?.expiry
}

export const isLoggedIn = () => {
  if (typeof window !== 'undefined') {
    if (isTokenExpired()) {
      return true
    } else {
      localStorage.clear()
    }
  }
}

export const getToken = (key) => {
  const item = doesTokenExist()

  if (isTokenExpired()) {
    return item.value
  } else {
    localStorage.removeItem(key)
    return null
  }
}

export const setToken = (key, value, ttl) => {
  const item = {
    value: value,
    expiry: ttl,
  }
  localStorage.setItem(key, JSON.stringify(item))
}
